var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon17BlogExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm2 0a8 8 0 1 1 16 0 8 8 0 0 1-16 0zm8-6.25A1.2 1.2 0 0 0 10.8 7l.22 5.63a.98.98 0 0 0 1.95 0L13.2 7A1.2 1.2 0 0 0 12 5.75zm-1.44 10.78a1.4 1.4 0 1 1 2.82 0 1.4 1.4 0 0 1-2.82 0z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik0yIDEyYTEwIDEwIDAgMSAwIDIwIDAgMTAgMTAgMCAwIDAtMjAgMHptMiAwYTggOCAwIDEgMSAxNiAwIDggOCAwIDAgMS0xNiAwem04LTYuMjVBMS4yIDEuMiAwIDAgMCAxMC44IDdsLjIyIDUuNjNhLjk4Ljk4IDAgMCAwIDEuOTUgMEwxMy4yIDdBMS4yIDEuMiAwIDAgMCAxMiA1Ljc1em0tMS40NCAxMC43OGExLjQgMS40IDAgMSAxIDIuODIgMCAxLjQgMS40IDAgMCAxLTIuODIgMHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPg0KPC9zdmc+DQo=";
export { SvgIcon17BlogExclamationMark as ReactComponent };